import { API_ROUTES } from "@command-center-app/constants/api.const";
import axiosService from "./axios.service";

export const uploadImageToS3 = async (payload: any) => {
  return await axiosService
    .post(API_ROUTES.UPLOAD_IMAGE_TO_S3, payload, {
      baseURL: import.meta.env.VITE_ALOHA_UPLOAD_URL,
    })
    .then((resp) => resp.data);
};
